import type { FunctionComponent } from "react"

import { useMemo } from "react"

import { Pagination } from "@/modules/jobAds/client/components/Pagination/Pagination"
import { useJobAdsFromAlgolia } from "@/modules/jobAds/client/hooks/useJobAdsFromAlgolia"
import { getDisplayedTotalCount } from "@/modules/jobSearch/helpers/getDisplayedTotalCount"

export const PaginationWrapper: FunctionComponent = () => {
  const { dataJobAds, isLoadingJobAds, isErrorJobAds } = useJobAdsFromAlgolia()

  const computedTotalSize = useMemo(() => {
    return getDisplayedTotalCount(dataJobAds?.totalSize || 0)
  }, [dataJobAds])

  if (!dataJobAds || isLoadingJobAds || isErrorJobAds) return null

  return <Pagination totalSize={computedTotalSize} />
}
